import React from "react";
import Grow from '@material-ui/core/Grow';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';

class MaterialCombobox extends React.Component {

    state = {
        value: this.props.input.value,
        suggestions: this.props.suggestions,
        listOpened: false,
        currentItem: -1
    };

    onBlur = () => {
        const { input } = this.props;
        input.onBlur();
        setTimeout(this.onListClose, 200);
    };

    onListClose = () => this.setState({ listOpened: false });

    onFocus = (e) => this.props.input.onFocus();

    onChange = (value) => this.props.input.onChange(value);

    pickSuggestion = (suggestion) => {
        this.onListClose();
        this.setState({ value: suggestion });
    }
    handleKeyDown = (e) => {
        const code = e.keyCode;
        const { currentItem, suggestions } = this.state;
        if([40,38,13].includes(code)) {
            e.preventDefault();
            if(suggestions.length > 0) {
                if(code === 40) {
                    this.setState({ currentItem: Math.min(currentItem + 1, suggestions.length-1) })
                }
                if(code === 38) {
                    this.setState({ currentItem: Math.max(0, currentItem - 1) })
                }
                if(code === 13) {
                    this.setState({ value: suggestions[currentItem] });
                    this.onListClose();
                }
            }
        } else {
            this.setState({ currentItem: -1 });
        }
    }

    componentDidUpdate() {
        this.onChange(this.state.value);
    }

    change = (e) => {
        const v = e.target.value;
        const { suggestions } = this.props;
        const foundedSuggestions = suggestions.filter(s => s.toLowerCase().includes(v.toLowerCase()));
        const listOpened = foundedSuggestions.length > 0;
        this.setState({
            listOpened,
            value: v,
            suggestions: foundedSuggestions
        });
    }

    render() {
        const { isTextarea, suggestionsLoaded, meta: { touched, error, warning } = {}, label } = this.props;
        const { suggestions, value, listOpened, currentItem } = this.state;
        return (
            <React.Fragment>
                <TextField error={touched && (Boolean(error || warning))}
                                    label={label}
                                    disabled={!suggestionsLoaded}
                                    rows={isTextarea ? 5 : null}
                                    multiline={isTextarea}
                                    margin="dense"
                                    FormHelperTextProps={{ classes: {error: "input-error", root: "input-error"} }}
                                    onChange={this.change}
                                    onFocus={this.onFocus}
                                    onBlur={this.onBlur}
                                    value={value}
                                    InputProps={{ classes: {multiline: "padded-textarea"}}}
                                    onKeyDown={this.handleKeyDown}
                                    InputLabelProps={{ shrink: true }}
                                    helperText={suggestionsLoaded ? touched && (error || warning) ? error || warning : "" : "Сбор подсказок..."}
                                    variant="outlined"
                                    fullWidth />
                {listOpened &&
                    <div className="autocomplete-container">
                        <Grow in={listOpened}>
                            <Paper className={`autocomplete-paper ${isTextarea ? "autocomplete-paper--wide" : ""}`}>
                                 {suggestions.map((s, i) => (
                                     <MenuItem selected={currentItem === i} key={i} component="div" onClick={() => this.pickSuggestion(s)}>{s}</MenuItem>
                                 ))}
                            </Paper>
                        </Grow>
                    </div>
                }
            </React.Fragment>
        );

    }
}

export default MaterialCombobox;



// WEBPACK FOOTER //
// ./src/components/MaterialCombobox.js